import React from 'react';
import { Link } from 'react-router-dom';

interface CtaFooterProps {
  headline: React.ReactNode;  // include <i> for gradient-accent treatment
  ctaLabel?: string;          // defaults to "Book intro call"
  ctaTo?: string;             // defaults to "/contact"
  direct?: { email: string; meta?: string };  // right-column "Direct" block
}

/**
 * Magenta-tinted CTA block placed at the bottom of every .ai public page.
 * Two-column on desktop (1.6fr headline, 1fr direct), single-column on
 * mobile via @media (max-width: 768px) rule in ai.css.
 */
export const CtaFooter: React.FC<CtaFooterProps> = ({
  headline,
  ctaLabel = 'Book intro call',
  ctaTo = '/contact',
  direct = { email: 'hello@intrnauts.ai', meta: 'UTC -8 · 1 business day reply' },
}) => (
  <section className="ai-cta">
    <div className="ai-cta-main">
      <h3 className="ai-cta-h3">{headline}</h3>
      <Link to={ctaTo} className="btn-magenta">{ctaLabel}</Link>
    </div>
    <aside className="ai-cta-direct">
      <h4 className="ai-cta-direct-label">Direct</h4>
      <p>{direct.email}{direct.meta ? <><br />{direct.meta}</> : null}</p>
    </aside>
  </section>
);

export default CtaFooter;
